export const MaskDefault = {
    phone : [
        {mask: '(00) 0000-0000'},
        {mask: '(00) 00000-0000'}
    ],
    cpf: "000.000.000-00",
    cnpj: "**.***.***/****-00",
    cep: "00000-000",
    salary: {
        mask: "R$ amount",
        blocks: {
            amount: {
                mask: Number,
                scale: 2,
                thousandsSeparator: ".",
                radix: ",",
                mapToRadix: ["."],
                normalizeZeros: true,
                padFractionalZeros: true,
                min: 0
            }
        }
    }
}

export const parseSalary = (value) => {
    const normalizedValue = String(value ?? "")
        .replace(/[^\d,.-]/g, "")
        .replace(/\./g, "")
        .replace(",", ".");

    return Number(normalizedValue) || 0;
};

export const formatSalary = (value) => new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
}).format(value);
